import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, FunnelService } from '../../../_services';
import { CrudSavePopupComponent } from '../../../_directives';
import { FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { StepPopupActions } from '../../../_models';
import { OfferData } from '../../../steps-library/step-util';

@Component({
  moduleId: module.id.toString(),
  selector: 'user-survey-popup',
  templateUrl: './user-survey-popup.component.html',
  styleUrls: ['../survey-steps.component.scss'],
})
export class UserSurveyPopup extends CrudSavePopupComponent implements OnInit {
  ngModelOptions = { standalone: true };
  StepPopupActions = StepPopupActions;
  title = 'survey';

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected formBuilder: FormBuilder,
    protected funnelService: FunnelService,
    protected alertService: AlertService
  ) {
    super(router, location, route, funnelService, alertService);
    this.objectName = 'Survey';
    this.isNew = false;
    this.isPartial = true;
  }

  ngOnInit() {
    this.setForm(
      this.formBuilder.group({
        name: [null, Validators.required],
      })
    );

    super.ngOnInit();
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.valid || this.inputData.popupType === StepPopupActions.Delete) {
      this.loading = true;
      const { popupType, offer_id, ...formData } = this.getFormData();

      let operation: Observable<Object>;
      let operationTitle = '';

      if (popupType === StepPopupActions.Update) {
        operationTitle = 'Updated';
        operation = this.funnelService.update(offer_id, formData);
      } else if (popupType === StepPopupActions.Delete) {
        operationTitle = 'Deleted';
        operation = this.funnelService.delete(offer_id);
      }

      operation.subscribe(
        (data) => {
          if (this.showSuccessMessage) {
            this.alertService.success(`${this.objectName} ${operationTitle} Successfully.`, true);
          }

          this.canDeactivateService.setFormDirty(false);
          this.onSaveComplete(data);
        },
        (error) => {
          this.handleSubmitError(error);
          this.loading = false;
        }
      );
    }
  }

  protected getFormData() {
    const data = {
      ...OfferData,
      ...this.form.value,
      offer_id: this.inputData.offer_id,
      offer_type: this.inputData.offer_type,
      offer_intent: this.form.value.offer_intent,
      popupType: this.inputData.popupType,
    };
    return data;
  }

  popupTypeTextMap: Partial<Record<StepPopupActions, string>> = {
    [StepPopupActions.Delete]: 'Delete',
    [StepPopupActions.Update]: 'Rename',
  };
}
